export default "__VITE_ASSET__Cay$cw8P__"